// extracted by mini-css-extract-plugin
export default {"card":"e1-z"};